import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {

  maxall: number = 20 
  history:any=[];
  nodata:any=[];
  isAllSelected: any;

  constructor(private service: ServiceService) { 
    this.dataSource.data = this.PeriodicElement;
  }

  PeriodicElement = [
    // {position: 1,ConsulationNo: '', DoctorName: '', TransactionId: '',Amount:'',CreatedDate:'',PaymentStatus:''},
  ];

  displayedColumns: string[] = ['position', 'Consultation No', 'Doctor Name', 'Transaction Id' , 'Amount' ,'Created Date','Payment Status'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  ngOnInit(): void {
    this.get_paymenthistory();
  }
  // toggleAllSelection() {
  //   this.isAllSelected = !this.isAllSelected;
  //   this.dataSource.paginator = this.isAllSelected ? null : this.paginator;
  // }
  get_paymenthistory() {
    this.service.Get_paymenthistory()
      .subscribe((data) => {
        this.history = data
        if(this.history.length>0)
        {
          //console.log("his data :" +this.history);
          this.dataSource= new MatTableDataSource(this.history);
          this.dataSource.paginator=this.paginator;
        }
        
      },
      (error:any)=>{
        //console.log("no data :" +this.history);
          this.dataSource= new MatTableDataSource(this.nodata);
          this.dataSource.paginator=this.paginator;
      })
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length <= 5 || this.dataSource.data.length <= 10)
      return [5, this.dataSource.data.length];
    if (this.dataSource.data.length <= this.maxall)
      return [5, 10, this.dataSource.data.length];
    else
      return [5, 10, 20, this.dataSource.data.length];
  }
}
